$(document).ready(function (e) {
	$("body").on(
		"click touch",
		".product__swatches-grid .product__swatches-item",
		function (e) {
			var _this = $(this);
			var url = $(this).data("url");
			var image = $(this).data("image");
			var currentItem = $(this).closest(".type-product-grid-item");

			currentItem.find(".product__swatches-item").removeClass("active");
			_this.addClass("active");

			currentItem
				.find(".increase-target")
				.attr("href", "/products/" + url);
			currentItem.find("img").attr("srcset", image);

			jQuery.getJSON("/products/" + url + ".js", function (product) {
				newImage = product.featured_image;
				currentItem.find("img").attr("srcset", newImage);
			});
		}
	);
});
